import { put, call, takeLatest, delay } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';

var packageJson = require('../../package.json');

function* footprintMyListGet(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('page', payload.page);
    return axios.post(config.apiUri + "member/footprintMyListApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "FOOTPRINT_MY_LIST_SET",
        payload: {
          list: res.data.list,
          page: action.payload.page,
          isList: res.data.isList,
          isListNext: res.data.isListNext,
          datetime: (new Date()),
        },
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* footprintMyItemDel(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'del');
    params.append('pic', payload.pic);
    params.append('version', packageJson.version);
    return axios.post(config.apiUri + "member/footprintMyEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {

    if (res.data.bool) {
      yield put({
        type: "SNACK_SET",
        payload: {
          visible: true,
          comment: "足あとを削除しました",
        },
      });
      yield put({
        type: "FOOTPRINT_MY_ITEM_SET",
        payload: {
          type: 'del',
          pic: action.payload.pic,
        },
      });
      yield put({
        type: "SEARCH_ITEM_FOOTPRINT_MY_SET",
        payload: {
          pic: action.payload.pic,
          value: 0,
        }
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* footprintPartnerListGet(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('page', payload.page);
    return axios.post(config.apiUri + "member/footprintPartnerListApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "FOOTPRINT_PARTNER_LIST_SET",
        payload: {
          list: res.data.list,
          page: action.payload.page,
          count: res.data.count,
          isListNext: res.data.isListNext,
        },
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* footprintPartnerItemDel(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'del');
    params.append('pic', payload.pic);
    return axios.post(config.apiUri + "member/footprintPartnerEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "FOOTPRINT_PARTNER_ITEM_SET",
        payload: {
          type: 'del',
          pic: action.payload.pic,
        },
      });

      yield put({
        type: "TIMELINE_FOOTPRINT_ITEM_SET",
        payload: {
          type: 'del',
          pic: action.payload.pic,
        },
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


const saga = [
  takeLatest('FOOTPRINT_MY_LIST_GET', footprintMyListGet),
  takeLatest('FOOTPRINT_MY_ITEM_DEL', footprintMyItemDel),
  takeLatest('FOOTPRINT_PARTNER_LIST_GET', footprintPartnerListGet),
  takeLatest('FOOTPRINT_PARTNER_ITEM_DEL', footprintPartnerItemDel),
];

export default saga;
